import React, { Component } from 'react'
import { History } from 'history'
import IndexHeaderRow from '../common/indexes/indexHeaderRow'

import { getHistory } from '../../helpers/localStorageHelper'
import { displayDollars } from '../../helpers/displayFormatHelper'

export interface Props {
  history: History
}

export class HistoryIndex extends Component<Props> {
  static displayName = 'HistoryIndex'

  openPage = (pathname) => {
    this.props.history.push({
      pathname,
    })
  }

  render() {
    const offers = getHistory(window.localStorage, 'offers')
    const refis = getHistory(window.localStorage, 'refis')

    const offersHeaderList = [
      { displayHeader: 'Seller (Last Name)', sortable: false },
      { displayHeader: 'Seller State', sortable: false },
      { displayHeader: 'Buyer (Last Name)', sortable: false },
      { displayHeader: 'Buyer State', sortable: false },
      { displayHeader: 'VIN', sortable: false },
      { displayHeader: 'Price', sortable: false },
    ]

    const refisHeaderList = [
      { displayHeader: 'Name', sortable: false },
      { displayHeader: 'State', sortable: false },
      { displayHeader: 'VIN', sortable: false },
    ]

    const offerRows = offers.map((offer) => {
      const { pathname, seller, sellState, buyer, buyState, vin, price } = offer
      return (
        <tr
          className="index-table__row"
          key={vin}
          data-testid="historyIndexOffersRow"
          onClick={() => this.openPage(pathname)}
        >
          <td className="index-table__cell">{seller}</td>
          <td className="index-table__cell">{sellState}</td>
          <td className="index-table__cell">{buyer}</td>
          <td className="index-table__cell">{buyState}</td>
          <td className="index-table__cell">{vin}</td>
          <td className="index-table__cell">
            {price && displayDollars(price)}
          </td>
        </tr>
      )
    })

    const refiRows = refis.map((refi) => {
      const { pathname, name, state, vin } = refi
      return (
        <tr
          className="index-table__row"
          key={vin}
          data-test="historyIndexRefisRow"
          onClick={() => this.openPage(pathname)}
        >
          <td className="index-table__cell">{name}</td>
          <td className="index-table__cell">{state}</td>
          <td className="index-table__cell">{vin}</td>
        </tr>
      )
    })

    return (
      <div>
        <div className="index" key="offers">
          <h1 className="index-table__header">Offers History</h1>
          <table className="index-table">
            <IndexHeaderRow headerList={offersHeaderList} parsedSearch={{}} />
            <tbody className="index-table__body">{offerRows}</tbody>
          </table>
        </div>

        <div className="index" key="refis">
          <h1 className="index-table__header">Refis History</h1>
          <table className="index-table">
            <IndexHeaderRow headerList={refisHeaderList} parsedSearch={{}} />
            <tbody className="index-table__body">{refiRows}</tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default HistoryIndex
